(() => {
  const loading = new Map();
  function load(host) {
    const url = host.dataset.runtimeUrl;
    if (!url || loading.has(url)) return;
    loading.set(
      url,
      import(url).catch(() => {
        loading.delete(url);
        // Leave the server-rendered fallback visible when the CDN is unavailable.
      }),
    );
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries
        .filter((entry) => entry.isIntersecting)
        .forEach(({ target }) => {
          observer.unobserve(target);
          load(target);
        });
    },
    { rootMargin: '300px' },
  );
  function scan() {
    document.querySelectorAll('salty-tour-pickup').forEach((host) => {
      if (host.dataset.designMode === 'true') load(host);
      else observer.observe(host);
    });
  }
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
